/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import fecha from 'fecha';
import Link from 'components/Link';
import Picture from '../../Hello/styles/Picture';
import Poster from '../../Hello/styles/Poster';

const Wrapper = styled.div`
  text-align: left;

  > time {
    display: inline-block;
    margin: 10px 0 10px;
    font-weight: 500;
  }

  > p {
    margin: 0;
    font-weight: 700;
  }
`;

const Announcement = ({ createdAt, title, content, piclink, poster, piclinkhref }) => (
  <Wrapper>
    {!poster && <time dateTime={createdAt}>{fecha.format(new Date(createdAt), 'DD.MM.YYYY')}</time>}
    {poster ? (
      <Link href={piclinkhref} target="_blank">
        <Poster
          style={{
            backgroundImage: piclink ? `url(${piclink})` : null,
          }}
        />
      </Link>
    ) : (
      <Link href={piclinkhref} target="_blank">
        <Picture
          style={{
            width: '100%',
            height: '700px',
            border: '1px solid var(--border-color)',
            backgroundImage: piclink ? `url(${piclink})` : null,
          }}
        />
      </Link>
    )}
    {!poster && <h3>{title}</h3>}
    {!poster && <div dangerouslySetInnerHTML={{ __html: content }} />}
  </Wrapper>
);

Announcement.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  piclink: PropTypes.string.isRequired,
  poster: PropTypes.bool.isRequired,
  piclinkhref: PropTypes.string.isRequired,
};

Announcement.defaultProps = {
  title: '',
};

export default Announcement;
